import React from "react";
import { Home } from "../tabs/home/home.tab";
import { Contact } from "../tabs/contact/contact.tab";
import { Services } from "../tabs/services/services.tab";
import { About } from "../tabs/about/about.tab";
import { PrivacyPolicy } from "../tabs/privacy-policy/privacy-policy.tab";
import { TermsAndConditions } from "../tabs/terms-and-conditions/terms-and-conditions.tab";
import { ethIcon } from "../utils/svg";

export enum TabKeys {
  Home = 1,
  About = 2,
  Services = 3,
  Contact = 4,
  PrivacyPolicy = 5,
  TermsAndConditions = 6,
}

export interface Tab {
  index: number;
  key: TabKeys;
  title: string;
  icon: string | undefined;
  component: React.ReactElement;
}

export const tabs: Tab[] = [
  {
    index: 1,
    key: TabKeys.Home,
    title: "Home",
    icon: ethIcon,
    component: <Home />,
  },
  {
    index: 2,
    key: TabKeys.About,
    title: "About",
    icon: ethIcon,
    component: <About />,
  },
  {
    index: 3,
    key: TabKeys.Services,
    title: "Services",
    icon: ethIcon,
    component: <Services />,
  },
  {
    index: 4,
    key: TabKeys.Contact,
    title: "Contact",
    icon: ethIcon,
    component: <Contact />,
  },
  {
    index: 5,
    key: TabKeys.PrivacyPolicy,
    title: "Privacy Policy",
    icon: undefined,
    component: <PrivacyPolicy />,
  },
  {
    index: 6,
    key: TabKeys.TermsAndConditions,
    title: "Terms and Conditions",
    icon: undefined,
    component: <TermsAndConditions />,
  },
];
